// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"713cb38e","232":"10aa1d1f","237":"0eab6821","526":"17f2c16f"}[chunkId] + ".chunk.js";
};